import { GenderCodes, SpoStatusValues, StatusCodeToKey } from 'const';

export function formTextWithGender(statusCode: number, gender?: number | null): string {
  const statusValue = SpoStatusValues[StatusCodeToKey[statusCode]];
  return statusValue === SpoStatusValues.employed && gender === GenderCodes.girl ? `${statusValue}а` : statusValue;
}
